import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "next-share";
import { FaWhatsapp } from "react-icons/fa";
import { FiFacebook, FiLinkedin, FiTwitter } from "react-icons/fi";
import styles from "./social_links.module.scss";

export const SocialSharingLinks = ({ url, title, hashtag, ...props }) => {
  return (
    <div
      className={`${styles.social_links_wrapper} ${props.className}`}
      style={props.style}
    >
      <FacebookShareButton url={url} quote={title} hashtag={hashtag}>
        <FiFacebook />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={title}>
        <FiTwitter />
      </TwitterShareButton>

      <LinkedinShareButton url={url}>
        <FiLinkedin />
      </LinkedinShareButton>

      <WhatsappShareButton url={url} title={title} separator=":: ">
        <FaWhatsapp />
      </WhatsappShareButton>
    </div>
  );
};

export default SocialSharingLinks;
